import { useCallback, useEffect, useState } from 'react';

export const usePagination = () => {
  const [total, setTotal] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [totalRowsCount, setTotalRowsCount] = useState(0);

  useEffect(() => {
    setTotalRowsCount(total);
  }, [total]);

  const change = useCallback(
    (page: number, pageSize: number) => {
      setRowsPerPage(pageSize);
      setPageNumber(pageSize === rowsPerPage ? page : 1);
    },
    [rowsPerPage]
  );

  return {
    pageNumber,
    rowsPerPage,
    totalRowsCount,
    setTotal,
    change,
    setPageNumber,
    setTotalRowsCount,
    setRowsPerPage,
  };
};
